import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import {  getBreakpointFromManor } from 'ctm-components';

// manor
import { GenericModal } from '@comparethemarketau/manor-modal';

const useStyles = createUseStyles((theme) => ({
    xs: {
        width: '100%'
    }
}));

const ApplicationErrorModal = ({ visible, children }) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <GenericModal
            trackingLabel={'Modal for application error'}
            overlay
            visible={visible}
            className={classNames('test-applicationError-modal', breakpoint === 'xs' && classes.xs)}
        >
            { children }
        </GenericModal>
    );
};

ApplicationErrorModal.propTypes = {
    visible: PropTypes.bool,
    children: PropTypes.node
};

export { ApplicationErrorModal };
